
import React from 'react'
import { format } from 'date-fns';
import { convertPascalCaseToWords, Proposal, ProposalContentType, SendProposalStatus, State } from '../../../core';
import loaderIcon from "./../../../../src/components/loader/Spinner.svg";
import { useSelector } from 'react-redux';
import { FormattedData } from './EditProposedCommercials';
import { LeadRequirement } from '../../../core/api/models/requirement';

interface IProposalPreviewHeaderProps {
    setStatusModalOpen: (modalState: { isOpen?: boolean; status?: SendProposalStatus }) => void;
    updating: boolean;
    commercialsEdited: boolean;
    setCommercialsEdited: (edited: boolean) => void;
    showYouWillLoseChangePopup: {
        isOpen: boolean;
        id: string | null;
        text: string;
        onPressYes: () => void;
    };
    setShowYouWillLoseChangePopup: (popupState: {
        isOpen: boolean;
        id: string | null;
        text: string;
        onPressYes: () => void;
    }) => void;
    canCreateProposal: boolean;
    canUpdateProposal: boolean;
    canApproveProposal: boolean;
    canRejectProposal: boolean;
    enableEdit: boolean;
    setEnableEdit: (enable: boolean) => void;
    requirementData: LeadRequirement | undefined;
    proposal: Proposal;
    loadedProposal: boolean | undefined;
    createData: any;
    downloadProposal: () => void;
    downloading: boolean | undefined;
    sendProposalEmail: () => void;
    sending: boolean | undefined;
    updateProposedCommercials: () => void;
    onClose: (() => void) | undefined;
    hideEdit: boolean | undefined;
    requirementId: string;
    setEditedProposedPropertyData: (React.Dispatch<React.SetStateAction<FormattedData[]>>) | undefined;
    isEdited: boolean | undefined;
    onEdit: ((id: string) => void) | undefined;
    isSaving: boolean | undefined;
    onSend: (() => void) | undefined;
    proposalIdForPreview: string | undefined;
    refreshComponent: (() => void) | undefined;
    hasAnyProposalApproved?: boolean;
}


const ProposalPreviewHeader: React.FunctionComponent<IProposalPreviewHeaderProps> = (props) => {

    const authUser = useSelector((state: State) => state.authUser);
    const profile = authUser?.profile;

    return (<div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
            <div className="col-auto" onClick={props.onClose}>
                <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col col-md-6">
                <div className="d-flex align-items-center">
                    {props.createData?.title ? <span className="requirement-title">{props.createData.title}</span> : <span className="requirement-title">
                        {props.requirementData?.cityDetails?.cityName},
                        {props.requirementData?.microMarketDetails?.map(x => x.cityZoneName)?.join()}
                    </span>}
                    {props.proposal?.versionNumber && <span className="ml-3 mr-2 requirement-title">
                        {" - "}V{props.proposal?.versionNumber}
                    </span>}
                    {props.proposal?.sendProposalStatus && <span className="border border-primary bg-white px-2 text-primary font-weight-semibold font-xxs rounded-sm requirement-title ml-2">
                        {convertPascalCaseToWords(props.proposal?.sendProposalStatus)}
                    </span>}
                </div>
                <div className="font-xs mt-1">
                    <span className="text-muted">Created by</span>{" "}
                    {profile?.name} <span className="text-muted">on</span>{" "}
                    {format(new Date(props.createData?.createdAt || new Date()), "dd/MM/yyyy hh:mm a")}{" "}
                    <span className="text-muted ml-2 pl-2" style={{
                        borderLeft: "1px solid #D9D9D9"
                    }}>
                        Format:
                    </span>{" "}
                    {props.createData?.proposalFormatType}
                    <span className="text-muted ml-2 pl-2" style={{
                        borderLeft: "1px solid #D9D9D9"
                    }}>
                        Type:
                    </span>{" "}
                    {props.createData?.proposalContentType === ProposalContentType.Small ? 'Short' : props.createData?.proposalContentType}
                </div>
            </div>

            {props.hasAnyProposalApproved === true ? null : <>
                {props.proposal?.sendProposalStatus !== SendProposalStatus.Approved && props.proposal?.sendProposalStatus !== SendProposalStatus.Rejected && props.loadedProposal && props.canUpdateProposal && !props.hideEdit && <div>
                    <div className="switch switch--sm">
                        <span className="font-sm  font-weight-semibold mr-1">
                            Edit Mode{" "}
                        </span>
                        <input type="checkbox" name="" onChange={() => {
                            if (props.commercialsEdited) {
                                props.setShowYouWillLoseChangePopup({
                                    isOpen: true,
                                    id: props.requirementId,
                                    text: 'You will lose the changes made to the proposed commercials. Are you sure you want to disable edit?',
                                    onPressYes: () => {
                                        if (props.setEditedProposedPropertyData) {
                                            props.setEditedProposedPropertyData([]);
                                        }

                                        props.setEnableEdit(false);
                                        props?.refreshComponent?.();
                                        props.setShowYouWillLoseChangePopup({
                                            isOpen: false,
                                            id: null,
                                            text: '',
                                            onPressYes: () => {//
                                            }
                                        });
                                        props.setCommercialsEdited(false);
                                    }
                                });
                            } else {
                                props.setEnableEdit(!props.enableEdit);
                            }
                        }} id="archiveSwitch" checked={props.enableEdit} />
                        <label htmlFor="archiveSwitch">
                            <div className="switch-handle ml-0 mr-2"></div>
                        </label>
                    </div>
                </div>}
                {(!props.proposal || props.isEdited === true) && props.loadedProposal && props.canCreateProposal && <div className="col-auto mt-md-0 mt-1 ml-auto">
                    {props.enableEdit && <span className="bg-white d-inline-block mr-2">
                        <button type="button" onClick={() => {
                            if (props.commercialsEdited) {
                                props.setShowYouWillLoseChangePopup({
                                    isOpen: true,
                                    id: props.requirementId,
                                    text: 'You will lose the changes made to the proposed commercials. Are you sure you want to leave this page?',
                                    onPressYes: () => {
                                        {
                                            if (props.setEditedProposedPropertyData) {
                                                props.setEditedProposedPropertyData([]);
                                            }

                                            props.onEdit?.(props.showYouWillLoseChangePopup?.id || '');
                                        }
                                    }
                                });
                            } else {
                                props.onEdit?.(props.requirementId);
                            }
                        }} className="btn btn-outline-secondary font-normal font-weight-bold py-2 rounded" disabled={props.isSaving}>
                            Configure
                        </button>
                    </span>}

                    {props.commercialsEdited && <button type="button" onClick={() => {
                        props.setCommercialsEdited(false);
                        props?.refreshComponent?.();
                    }} className="btn btn-outline-secondary mr-2 px-4 font-normal font-weight-bold py-2 rounded" disabled={props.isSaving}>
                        Cancel
                    </button>}

                    {(!props.enableEdit || props.commercialsEdited) && <button type="button" onClick={props.onSend} className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded" disabled={props.isSaving}>
                        {props.commercialsEdited && props.proposalIdForPreview ? "Save changes" : "Request For Approval"}
                    </button>}
                </div>}
                {props.proposal?.sendProposalStatus === SendProposalStatus.Requested && props.isEdited !== true && <div className="col-auto mt-md-0 mt-1 ml-auto">
                    {!props.hideEdit && props.enableEdit && <span className="bg-white d-inline-block mr-2">
                        <button type="button" onClick={() => {
                            if (props.commercialsEdited) {
                                props.setShowYouWillLoseChangePopup({
                                    isOpen: true,
                                    id: props.requirementId,
                                    text: 'You will lose the changes made to the proposed commercials. Are you sure you want to leave this page?',
                                    onPressYes: () => {
                                        props.onEdit?.(props.proposal.masterRequirementId || '');
                                    }
                                });
                            } else {
                                props.onEdit?.(props.proposal.masterRequirementId);
                            }
                        }} className="btn btn-outline-secondary font-normal font-weight-bold py-2 rounded" disabled={props.isSaving}>
                            Configure
                        </button>
                    </span>}

                    {props.enableEdit && props.commercialsEdited && <>
                        <button type="button" onClick={() => {
                            props.setCommercialsEdited(false);
                            props?.refreshComponent?.();
                        }} className="btn btn-outline-secondary mr-2 px-4 font-normal font-weight-bold py-2 rounded" disabled={props.isSaving}>
                            Cancel
                        </button>

                        <button type="button" onClick={() => {
                            props.updateProposedCommercials();
                        }} className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded" disabled={props.isSaving}>
                            Save changes
                        </button>
                    </>}

                    {!props.enableEdit && <>
                        <span className="bg-white d-inline-block mr-2">
                            {props.canRejectProposal && <button type="button" onClick={() => props.setStatusModalOpen({
                                isOpen: true,
                                status: SendProposalStatus.Rejected
                            })} className="btn btn-outline-secondary px-5 font-normal font-weight-bold py-2 rounded" disabled={props.updating}>
                                Reject
                            </button>}
                        </span>
                        {props.canApproveProposal && <button type="button" onClick={() => props.setStatusModalOpen({
                            isOpen: true,
                            status: SendProposalStatus.Approved
                        })} className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded" disabled={props.updating}>
                            Approve
                        </button>}
                    </>}

                </div>}
            </>}

            {props.proposal?.sendProposalStatus === SendProposalStatus.Approved && <div className="col-auto mt-md-0 mt-1 ml-auto">
                <span className="bg-white d-inline-block mr-2">
                    <button type="button" onClick={() => props.downloadProposal()} // onClick={handlePrint}
                        // onClick={() => printFn()}
                        className="btn btn-outline-secondary px-5 font-normal font-weight-bold py-2 rounded" disabled={props.downloading} style={{
                            width: '234px',
                            height: '36px'
                        }} // Set a fixed width
                    >
                        {props.downloading ? <>
                            <img src={loaderIcon} alt={".."} width={24} height={24}></img>
                            Loading...
                        </> : "Download Proposal"}
                    </button>
                </span>
                <button type="button" onClick={() => props.sendProposalEmail()} className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded" disabled={props.sending}>
                    Send Proposal
                </button>
            </div>}

        </div>
    </div>);
}


export default ProposalPreviewHeader